import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-58419113"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pagination-component" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_pagination, {
      "current-page": _ctx.currentPage,
      background: "",
      "page-sizes": [10, 20, 30],
      "page-size": _ctx.pageSize,
      total: _ctx.total,
      onSizeChange: _ctx.handleSizeChange,
      onCurrentChange: _ctx.handleCurrentChange,
      layout: "total, sizes, prev, pager, next, jumper"
    }, {
      total: _withCtx(() => [
        _createElementVNode("span", null, "共 " + _toDisplayString(_ctx.total) + " 条", 1)
      ]),
      _: 1
    }, 8, ["current-page", "page-size", "total", "onSizeChange", "onCurrentChange"])
  ]))
}